import React from 'react';
import s from './Subtotal.module.scss';
import Button from 'components/shared/Button';
import { BasketSteps } from '../ShoppingCart';
import { useTranslation } from 'react-i18next';
import useIsAuth from 'sdk/hooks/useIsAuth';

import { ReactComponent as RiyalIcon } from 'images/new-icons/riyal.svg';

const Subtotal = ({ data, setStep, onClose }) => {
  const { t } = useTranslation() as any;
  const totalPrice = data?.reduce((acc, item) => acc + item.actions_price, 0);
  const { data: isAuthData } = useIsAuth();
  const userId = isAuthData?.user?.id;
  return (
    <div className={s.container}>
      <div className={s.products}>
        {t('Products')} {`(${data?.length})`}
      </div>
      <div className={s.subtotal}>
        <div>{t('Subtotal')}</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <RiyalIcon style={{ width: '14px', height: '14px' }} />
          {totalPrice.toFixed(2)}
        </div>
      </div>
      <div className={s.caption}>{t('Without VAT & delivery')}</div>
      <div className={s.action}>
        {/* <Button wide white onClick={onClose} className={s.button_secondary}>
          {t('Continue Shopping')}
        </Button> */}
        <Button
          wide
          darkGreen
          className={s.button_primary}
          onClick={() => {setStep(BasketSteps.CHECKOUT)}}
        >
          {t('Buy Now')}
        </Button>
      </div>
    </div>
  );
};

export default Subtotal;
